import React from 'react'
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import {useHistory} from 'react-router-dom'
import styled from 'styled-components';


const ViewMoreDetails = styled.td`
cursor: pointer;
text-decoration: underline;
color: #0A3BB4;
`

const Title = styled.div`
    align-items: center;
    justify-content: center;
    display: flex;
    text-align: center;
    margin: auto;
    padding-bottom: 20px;
    font-size: 40px;
    font-weight:500;
`;

function CompanyJobs({ JobList }) {

    const history = useHistory();

    return JobList.length != 0 ? (
        <div>
            <Title>My Job Posts</Title>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Title</th>
                        <th>Category</th>
                        <th>Type</th>
                        <th>Location</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        JobList.map((job, index) => {

                            return (
                            <tr key={index}>
                                <td>{index + 1 }</td>
                                <td>{job.Title}</td>
                                <td>{job.Category}</td>
                                <td>{job.Type}</td>
                                <td>{job.Location}</td>
                                <ViewMoreDetails style={{}} onClick={() => {
                                    history.push('/Job/'+job.JobId)
                                }}>View More Details</ViewMoreDetails>
                            </tr>
                            );
                        })
                    }
                    
                </tbody>
            </Table>
        </div>
    ): (<div> 
        <Title style={{color:'#0A3BB4', paddingBottom:'0px'}}>You don't have any job posts created! </Title>
        <Title style={{fontSize:'20px', fontWeight:'400'}}>To post a new job, click on Post Job</Title>
       </div>)
}

CompanyJobs.propTypes = {

}

export default CompanyJobs

